import { render, staticRenderFns } from "./RetailerProductPrice.vue?vue&type=template&id=0cde53ba"
import script from "./RetailerProductPrice.vue?vue&type=script&setup=true&lang=ts"
export * from "./RetailerProductPrice.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports